import {ComponentFactoryResolver,ComponentRef,Directive,Input,OnInit,ViewContainerRef} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldConfig } from "../models/field.interface";
import { shortTextComponent } from "../fields/short-text/short-text.component";
import { longTextComponent } from "../fields/longtext/long-text.component";
import {ImagePickerComponent} from '../fields/imagePicker/imagePicker.component';
import {ReadTextComponent} from '../fields/read-text/read-text.component'
import {HazardComponent} from '../fields/hazard/hazard.component';
import {DatePickerComponent} from '../fields/date-picker/date-picker.component';
import {NumberFieldComponent} from '../fields/number-field/number-field.component';
import {TimePickerComponent} from '../fields/time-picker/time-picker.component';
import {CheckBoxComponent} from '../fields/check-box/check-box.component';
import {LocationComponent} from '../fields/location/location.component';
import { SignatureComponent } from '../fields/signature/signature.component';
import {BulkGroupComponent} from '../fields/bulk-group/bulk-group.component';
import { MultiChoiceComponent } from '../fields/multi-choice/multi-choice.component';
import {HazardWithLabelComponent} from '../fields/hazard-with-label/hazard-with-label.component';
import {GroupQuestionComponent} from '../fields/group-question/group-question.component';
import {MultiChoiceListComponent} from '../fields/multi-choice-list/multi-choice-list.component';
import {CheckBoxListComponent} from '../fields/check-box-list/check-box-list.component';
import {UserListComponent} from '../fields/user-list/user-list.component';
import {WorkOrderIdComponent} from '../fields/work-order-id/work-order-id';
import { SectiontitleComponent } from '../fields/sectiontitle/sectiontitle.component';
import { FreeFormDrawComponent } from "../fields/free-form-draw/free-form-draw.component";
import { UrlComponent } from "../fields/url/url.component";
import { PdfFieldComponent } from "../fields/pdf-field/pdf-field.component";
import { FormFieldComponent } from "../fields/form-field/form-field.component";
import { IncidentsListComponent } from "../fields/incidents-list/incidents-list.component";
import { MultiChoiceTemplateComponent } from "../fields/multi-choice-template/multi-choice-template.component";
import { RatingComponent } from "../fields/rating/rating.component"
import { ActionWorkOrderIdComponent } from "../fields/action-work-order-id/work-order-id";
import { ActionComponent } from "../fields/action/action.component";
import { InspectionQuestionComponent } from "../fields/Inspection-question/inspection-question.component";
import { FilePickerComponent } from "../fields/file/file.component";

const componentMapper = {
  text: shortTextComponent,
  textBox : longTextComponent,
  label : ReadTextComponent,
  date : DatePickerComponent,
  time : TimePickerComponent,
  number : NumberFieldComponent,
  singleSelection : MultiChoiceComponent,
  singleSelectionList : MultiChoiceListComponent,
  multiSelection : CheckBoxComponent,
  multiSelectionList : CheckBoxListComponent,
  gps : LocationComponent,
  signature : SignatureComponent,
  imagePicker : ImagePickerComponent,
  dynamic : BulkGroupComponent,
  singleSelectionWithHeading : GroupQuestionComponent,
  hazard : HazardComponent,
  action : ActionComponent,
  hazardWithLabel : HazardWithLabelComponent,
  userList: UserListComponent,
  customWorkOrderId: WorkOrderIdComponent,
  customActionWorkOrderId: ActionWorkOrderIdComponent,
  sectionTitle: SectiontitleComponent,
  freeFormDraw : FreeFormDrawComponent,
  url : UrlComponent,
  pdf : PdfFieldComponent,
  form: FormFieldComponent,
  incidentsList : IncidentsListComponent,
  subForm: MultiChoiceTemplateComponent,
  rating: RatingComponent,
  inspection: InspectionQuestionComponent,
  file: FilePickerComponent
}; 

@Directive({
  selector: '[appField]'
})
export class FieldDirective {

  @Input() field: FieldConfig;
  @Input() group: FormGroup;
  componentRef: any;
  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef
  ) {}
  ngOnInit() {
    const factory = this.resolver.resolveComponentFactory(
      componentMapper[this.field.type]
    );
    this.componentRef = this.container.createComponent(factory);
    this.componentRef.instance.field = this.field;
    this.componentRef.instance.group = this.group;
  }

}



// WEBPACK FOOTER //
// ./src/app/rFF/directives/field.directive.ts